"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildAttendanceIntention = void 0;
const date_fns_1 = require("date-fns");
const types_1 = require("@hoepel.app/types");
const week_identifier_1 = require("../week-identifier");
const locale_1 = require("date-fns/locale");
/** When parents register their children, we register them for one week at a time */
class ChildAttendanceIntention {
    constructor(props) {
        this.props = props;
    }
    get id() {
        return `${this.tenantId}-${this.childId}-${this.year}-${this.weekNumber}`;
    }
    toProps() {
        return this.props;
    }
    static fromProps(props) {
        return new ChildAttendanceIntention(props);
    }
    static create(tenantId, childId, preferredBubbleName, year, weekNumber, shiftIds, created, status = 'pending') {
        return new ChildAttendanceIntention({
            tenant: tenantId,
            childId,
            preferredBubbleName,
            created: created.getTime(),
            status,
            edited: null,
            year,
            weekNumber,
            shifts: shiftIds.map((id) => {
                return {
                    didAttend: false,
                    id,
                };
            }),
        });
    }
    get weekNumber() {
        return this.props.weekNumber;
    }
    get year() {
        return this.props.year;
    }
    get created() {
        return new Date(this.props.created);
    }
    get edited() {
        if (this.props.edited == null) {
            return null;
        }
        return new Date(this.props.edited);
    }
    get status() {
        return this.props.status;
    }
    withStatus(status) {
        return ChildAttendanceIntention.fromProps({
            ...this.toProps(),
            status,
        });
    }
    withChildId(childId) {
        return ChildAttendanceIntention.fromProps({
            ...this.toProps(),
            childId,
        });
    }
    get shifts() {
        return this.props.shifts;
    }
    get weekStart() {
        const dateZero = new Date(0);
        const date = date_fns_1.startOfWeek(date_fns_1.setWeek(date_fns_1.setYear(dateZero, this.props.year), this.weekNumber, {
            weekStartsOn: 1,
            locale: locale_1.nlBE,
        }), { weekStartsOn: 1, locale: locale_1.nlBE });
        return types_1.DayDate.fromNative(date);
    }
    get weekIdentifier() {
        return week_identifier_1.WeekIdentifier.fromWeekIdentifier(`${this.year}-${this.weekNumber}`);
    }
    get preferredBubbleName() {
        return this.props.preferredBubbleName;
    }
    get tenantId() {
        return this.props.tenant;
    }
    get childId() {
        return this.props.childId;
    }
    get shiftIds() {
        return this.props.shifts.map((shift) => shift.id);
    }
}
exports.ChildAttendanceIntention = ChildAttendanceIntention;
//# sourceMappingURL=child-attendance-intention.js.map